module.exports = __webpack_public_path__ + "media/assets/heart_icon-b8fabc0a.svg";